




import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component
export default class Icon extends Vue {
    @Prop(String) public title?: string;
    @Prop({ type: String, required: true }) public name!: string;

    public get iconComponent() {
        return this.dynamicComponent(this.name);
    }

    private dynamicComponent(name: string) {
        return () => import(`@/assets/icons/${name}.svg`);
    }
}
